import { render } from "./TheBankAccountList.vue?vue&type=template&id=e59da810&scoped=true&ts=true"
import script from "./TheBankAccountList.vue?vue&type=script&lang=ts"
export * from "./TheBankAccountList.vue?vue&type=script&lang=ts"

import "./TheBankAccountList.vue?vue&type=style&index=0&id=e59da810&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59da810"]])

export default __exports__